import { useEffect, useState } from 'react'
import { Pencil, Plus, Save, Trash2, X } from 'lucide-react'
import { useNotification } from '@context/NotificationContext'
import ApiService from '@services/api'

const PERMISSIONS = [
  ['users.view', 'Usuários'], ['users.list', 'Listar usuários'], ['users.edit', 'Editar usuários'],
  ['board.view', 'Kanban'], ['dashboard.view', 'Dashboard Performance'],
  ['reports.view', 'Relatórios'], ['reports.processes.view', 'Relatórios por cliente'], ['reports.clickbus.view', 'Relatório ClickBus'],
  ['simulator.view', 'Simulador de Prazos'], ['simulator.settings.manage', 'Configurações do Simulador'], ['forms.view', 'Fichas RH'],
  ['templates.manage', 'Modelos de peças'],
]

const emptyForm = { id: null, nome: '', permissions: [] }
const HIDDEN_SYSTEM_ROLE_IDS = new Set([3, 4])
const roleLabel = (role) => ({ ADMIN: 'Administrador', LAWYER: 'Advogado' }[role.nome] || role.nome)
const rolePermissionsLabel = (role) => (role.permissions || [])
  .filter((key) => key !== 'users.create')
  .map((key) => PERMISSIONS.find(([id]) => id === key)?.[1] || key)
  .join(' · ') || 'Sem acessos configurados'

export default function RolesTab({ onRolesChange }) {
  const { showError, showSuccess } = useNotification()
  const [roles, setRoles] = useState([])
  const [form, setForm] = useState(null)
  const [loading, setLoading] = useState(true)

  const load = async () => {
    setLoading(true)
    const result = await ApiService.getPerfis()
    if (result.success) { setRoles(result.data || result.items || []); onRolesChange?.(result.data || result.items || []) }
    else showError(result.error || 'Não foi possível carregar os perfis.')
    setLoading(false)
  }
  useEffect(() => { load() }, [])

  const save = async () => {
    if (!form.nome.trim()) return showError('Informe o nome do perfil.')
    const action = form.id ? ApiService.updatePerfil(form.id, form) : ApiService.createPerfil(form)
    const result = await action
    if (!result.success) return showError(result.error || 'Não foi possível salvar o perfil.')
    showSuccess('Perfil salvo com sucesso.'); setForm(null); await load()
  }
  const remove = async (role) => {
    if (!window.confirm(`Excluir o perfil ${role.nome}?`)) return
    const result = await ApiService.deletePerfil(role.id)
    if (!result.success) return showError(result.error || 'Este perfil ainda possui usuários vinculados.')
    showSuccess('Perfil excluído.'); await load()
  }

  return <section className="roles-tab">
    <div className="roles-tab-header"><div><h2>Perfis e permissões</h2><p>Defina quais telas e recursos cada perfil pode acessar. A criação de usuários é exclusiva dos perfis Admin e Super Admin.</p></div><button className="btn btn-primary" onClick={() => setForm(emptyForm)}><Plus size={16} /> Novo perfil</button></div>
    {form ? <div className="roles-editor"><label>Nome do perfil<input className="users-text-input" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} placeholder="Ex.: Advogado - Líder Tributário" /></label><strong>Permissões</strong><div className="roles-permissions">{PERMISSIONS.map(([key, label]) => <label className="users-checkbox-row" key={key}><input type="checkbox" checked={form.permissions.includes(key)} onChange={(e) => setForm({ ...form, permissions: e.target.checked ? [...form.permissions, key] : form.permissions.filter((item) => item !== key) })} />{label}</label>)}</div><div className="roles-editor-actions"><button className="btn btn-outline" onClick={() => setForm(null)}><X size={16} /> Cancelar</button><button className="btn btn-primary" onClick={save}><Save size={16} /> Salvar perfil</button></div></div> : null}
    <div className="roles-list">{loading ? <p>Carregando perfis...</p> : roles.filter((role) => !HIDDEN_SYSTEM_ROLE_IDS.has(role.id)).map((role) => <article className="roles-card" key={role.id}><div><h3>{roleLabel(role)}</h3><p>{rolePermissionsLabel(role)}</p><small>{role.userCount || 0} usuário(s) vinculado(s)</small></div><div className="roles-card-actions"><button className="btn btn-outline" onClick={() => setForm({ id: role.id, nome: role.nome, permissions: role.permissions || [] })}><Pencil size={16} /> Editar</button>{!role.systemRole ? <button className="btn btn-outline roles-delete" onClick={() => remove(role)}><Trash2 size={16} /></button> : null}</div></article>)}</div>
  </section>
}
